import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/pages/layout/AppLayout';

export const Route = createFileRoute('/_authenticated/_app')({
	component: AppLayout,
});
